<template>
  <page-wrap>
    <layout :isEmpty="!rfqID" :messageEmpty="L10n('select-a-customer-po-open')" :error="error">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <tools-panel
          :rfqID="rfqID"
          :disabledCreatePoWo="disabledCreatePoWo"
          :showNew="showNew"
          @onChange="handleSelect"
          @onNew="handleNew"
          @onCreatePO="handleCreatePO"
          @onCreateWO="handleCreateWO"
        />
      </template>
      <template v-slot:content>
        <editor :rfqid="dataRFQ.rfqid" :listRFQ2.sync="listRFQ2" />
      </template>
      <editor />
    </layout>
    <dialog-create-po-wo
      ref="dialog-create-po-wo"
      :actionName="actionName"
      :selectedList="selectedList"
      :formModel="formModel"
      :dataRFQ="dataRFQ"
      :updatePoDate="false"
      @onCreatedPO="goToChosenTrue"
    />
  </page-wrap>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'
import { ModelSharedForm, ServiceRFQs } from '@/services/RFQs'

export default {
  name: 'PoWoBasedOnCustomerPoOpen',
  mixins: [routeEditLogic],
  props: {
    config: {
      default: () => ({
        id: 'rfq'
      })
    }
  },
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'editor': () => import(/* webpackChunkName: 'PoWoBasedOnCustomerPoOpen' */ './Editor'),
    'tools-panel': () => import(/* webpackChunkName: 'PoWoBasedOnCustomerPoOpen' */ './ToolsPanel'),
    'dialog-create-po-wo': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/DialogCreatePoWo')
  },
  data () {
    return {
      rfqID: null,
      error: null,
      actionName: 'create-wo',
      dataRFQ: {},
      listRFQ2: []
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    },
    selectedList () {
      return this.listRFQ2.filter(item => !!item['custom_chosen'])
    },
    disabledCreatePoWo () {
      return this.selectedList.length === 0
    },
    showNew () {
      return !!(this.rfqID && Object.keys(this.dataRFQ))
    }
  },
  methods: {
    formModel () {
      const { po, rfqTypeID, rfqid, customerCompanyID, customerContactID, customerCompanyDetailID } = this.dataRFQ

      return this.copyObjectProps(ModelSharedForm(), {
        rfqTypeID,
        po,
        rfqid,
        customerCompanyID,
        customerContactID,
        customerCompanyDetailID
      })
    },
    handleSelect (id) {
      this.mixSetRoute({ value: id && Number(id) })
    },
    handleNew () {
      this.$router.replace({ query: Object.assign({}, this.$route.query, { 'po-wo-based-customer': 'new' }) })
    },
    loadCurrentRFQ () {
      if (!this.rfqID) {
        return
      }
      const params = {
        select: [
          'id', 'rfqid', 'pOisOpen', 'po', 'rfqTypeID',
          'customerCompanyID', 'customerContactID', 'customerCompanyDetailID'
        ].join(',')
      }
      return ServiceRFQs
        .getDynamic(this.rfqID, params)
        .then(({ data }) => {
          if (!data.poIsOpen) {
            this.error = new Error('po-is-closed')
            this.dataRFQ = {}
          }
          this.dataRFQ = data
        })
    },
    handleCreatePO () {
      this.actionName = 'create-supplier-po'
      this.$refs['dialog-create-po-wo'].show()
    },
    handleCreateWO () {
      this.actionName = 'create-wo'
      this.$refs['dialog-create-po-wo'].show()
    },
    goToChosenTrue (rfqID, salesOrderID) {
      let query = { 'supplier-quotes-rfq2-chosen-true': `edit[${salesOrderID}]` }
      this.$router.replace({ name: 'SupplierPoWoOpen', query })
    },
    // Mixins
    mixHookReset () {
      this.rfqID = null
      this.dataRFQ = {}
      this.listRFQ2 = []
    },
    mixHookState ({ value, state }) {
      this.rfqID = value && Number(value)
      this.loadCurrentRFQ()
    }
  }
}
</script>
